import React from 'react'

export const Loader = () => {
  return (
    <div className="load-bar">
    <div className='bar'></div>
    <div className='bar'></div>
    <div className='bar'></div>
    </div>
  )
}
